export const layout = {
  chat_header_height: '52px',
  chat_navigation_height: '66px',
  section_side: '16px',
  assetStore_canvas_height: '400px',
} as const;

export type Layout = typeof layout;
